import React, { useEffect } from 'react'
import { Button } from '@material-ui/core'

function ThankYou(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const token = localStorage.getItem(['__react_session__'])
  const [jsontoken, setJsonToken] = React.useState(JSON.parse(token))

  useEffect(() => {
    setJsonToken(JSON.parse(token))
  }, [token])

  const handleClick = () => {
    window.history.back()
  }

  const OpenTrackingPage = (id, prepMeal) => {
    id = parseInt(id)
    localStorage.setItem('currentOrderId', id)
    localStorage.setItem('currentOrderIsPrepMeal', prepMeal)
    window.location.href = '/track-order'
  }

  const OpenReceiptPage = (id, prepMeal) => {
    id = parseInt(id)
    localStorage.setItem('currentOrderId', id)
    localStorage.setItem('currentOrderIsPrepMeal', prepMeal)
    window.location.href = '/receipt-order'
  }

  const params = new URLSearchParams(window.location.search)

  if (params.get('d') === 'error') {
    return (
      <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
        <div
          className="main-wrapper inner--page"
          style={{ backgroundColor: '#eff0f2' }}
        >
          <section className="thankyou-sec">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 offset-lg-2">
                  <div className="main-box">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <div className="section-header-center">
                          <h2 style={{ color: '#ff0000' }}>
                            Your order not approved.
                          </h2>
                        </div>
                      </div>
                      <div className="col-lg-12 text-center">
                        <div className="payment-sec cct">
                          <h4>{params.get('message')}</h4>
                          <div className="form-group">
                            <a href={'/checkout'} className="primary-btn">
                              Back
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  } else {
    return (
      <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
        <div
          className="main-wrapper inner--page"
          style={{ backgroundColor: '#eff0f2' }}
        >
          <section className="thankyou-sec">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 offset-lg-2">
                  <div className="main-box">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h4>You are set!</h4>
                        <div className="section-header-center">
                          <h2 className={'text-success'}>
                            Thank you for your Order
                          </h2>
                        </div>
                      </div>
                      <div className="col-lg-12 text-center">
                        <div className="payment-sec cct">
                          <h6 className="text-warning mb-4">
                            Your order could take up to 5 minutes to display an
                            &quot;Accept&quot; notification. We appreciate your
                            patience
                          </h6>

                          {jsontoken ? (
                            <>
                              <h4>Check your order status in the link below</h4>
                              <div className="form-group">
                                <button
                                  className="primary-btn mr-2"
                                  onClick={() => {
                                    OpenTrackingPage(
                                      params.get('d'),
                                      params.get('schedule')
                                        ? params.get('schedule')
                                        : 0,
                                    )
                                  }}
                                >
                                  Track
                                </button>
                                <button
                                  className="primary-btn"
                                  onClick={() => {
                                    OpenReceiptPage(
                                      params.get('d'),
                                      params.get('schedule')
                                        ? params.get('schedule')
                                        : 0,
                                    )
                                  }}
                                >
                                  Receipt
                                </button>
                              </div>
                            </>
                          ) : (
                            <Button
                              size="large"
                              variant="contained"
                              style={{
                                backgroundColor: '#12824C',
                                color: '#FFFFFF',
                              }}
                              onClick={handleClick}
                            >
                              Go Back
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default ThankYou
